'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.googleWrapper = exports.geocodeByPlaceId = exports.getFilterClass = exports.placesAutocomplete = undefined;

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _constants = require('./constants');

var _isomorphicHelpers = require('./isomorphic-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var placesAutocomplete = exports.placesAutocomplete = function placesAutocomplete(text) {
  if (typeof window === 'undefined') return Promise.resolve();
  var autocompleteService = new window.google.maps.places.AutocompleteService();
  var request = {
    input: text,
    componentRestrictions: {
      country: 'uk'
    }
  };
  return new Promise(function (resolve) {
    return autocompleteService.getPlacePredictions(request, resolve);
  });
};

var getFilterClass = exports.getFilterClass = function getFilterClass(types) {
  if (!types || !(0, _isArray3.default)(types)) {
    return 3;
  }
  var regionClasses = {
    'postal_code': 3, // e.g., NW1 8AB
    'administrative_area_level_1': 2,
    'administrative_area_level_2': 2,
    'neighborhood': 2, // e.g., Camden Town, London
    'postal_code_prefix': 2, // e.g., NW1
    'route': 2, // e.g., Harley Street London
    'locality': 1, // e.g., London
    'sublocality': 1
  };
  return types.reduce(function (returnedType, type) {
    return regionClasses[type] || returnedType;
  }, 3);
};

var geocodeByPlaceId = exports.geocodeByPlaceId = function geocodeByPlaceId(placeId) {
  if ((0, _isomorphicHelpers.isServerSide)()) return Promise.resolve();
  var geocoderService = new window.google.maps.Geocoder();
  var request = {
    placeId: placeId
  };
  return new Promise(function (resolve) {
    return geocoderService.geocode(request, resolve);
  });
};

var googleWrapper = exports.googleWrapper = function googleWrapper(func) {
  if (!(0, _isomorphicHelpers.isServerSide)() && !window.google) {
    var GoogleMapsLoader = require('google-maps');
    GoogleMapsLoader.LIBRARIES = ['places'];
    if (!(0, _isomorphicHelpers.isServerSide)() && window.location && window.location.host && !window.location.host.includes('localhost')) {
      GoogleMapsLoader.KEY = _constants.GOOGLE_MAP_KEY;
    }
    GoogleMapsLoader.load(function () {
      return func();
    });
  } else {
    func();
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/google.js
// module id = 590
// module chunks = 0